/**
 * API base URL for the Eazylink backend (Next.js admin portal / API server).
 * Leave empty in development to use CRA proxy (see src/setupProxy.js).
 */
export const API_BASE = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

export const apiUrl = (path) => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE}${normalizedPath}`;
};
